import { mapActions, mapGetters, mapMutations } from 'vuex';
import _debounce from 'lodash/debounce';

import { USER_LEVEL } from '@/utils/constants';

export default {
  name: 'Sidebar',
  props: {
    value: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      items: [
        {
          name: '一起訂東西',
          to: '/order/list',
          icon: 'icon-cart',
          isActive: 'isOrderListTabActive',
          wrapperId: 'sidebar-order-list',
          visible: 'isGreaterThanHead',
          bottom: false,
        },
        {
          name: '店家管理',
          to: '/store/list',
          icon: 'icon-shop',
          isActive: 'isStoreTabActive',
          wrapperId: 'sidebar-store-list',
          visible: 'isGreaterThanHead',
          bottom: false,
        },
        {
          name: '人員管理',
          to: '/member/list',
          icon: 'icon-members',
          isActive: 'isMemberTabActive',
          wrapperId: 'sidebar-member-list',
          visible: 'isGreaterThanHead',
          bottom: false,
        },
        {
          name: '統計報表',
          to: '/statistics/group_buyings',
          icon: 'icon-trend',
          isActive: 'isStatisticsTabActive',
          wrapperId: 'sidebar-statistics',
          visible: 'isGreaterThanAdmin',
          bottom: false,
        },
        {
          name: '公司帳戶',
          to: '/setting',
          icon: 'icon-cog',
          wrapperId: 'sidebar-settings',
          visible: 'isOwner',
          bottom: false,
        },
        {
          name: '個人資訊',
          to: '/user-info',
          icon: 'icon-member',
          wrapperId: null,
          visible: true,
          bottom: true,
        },
        {
          name: '登出',
          icon: 'icon-logout',
          wrapperId: null,
          action: this.logout,
          visible: true,
          bottom: false,
        },
      ],
    };
  },
  computed: {
    sidebarCollapsed: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isOrderListTabActive() {
      return /^\/order\//.test(this.$route.fullPath);
    },
    isStoreTabActive() {
      return /^\/store\//.test(this.$route.fullPath);
    },
    isMemberTabActive() {
      return /^\/member\//.test(this.$route.fullPath);
    },
    isStatisticsTabActive() {
      return /^\/statistics\//.test(this.$route.fullPath);
    },
    isGreaterThanHead() {
      return this.currentRole >= USER_LEVEL.HEAD;
    },
    isGreaterThanAdmin() {
      return this.currentRole >= USER_LEVEL.ADMIN;
    },
    isOwner() {
      return this.currentRole >= USER_LEVEL.OWNER;
    },
    ...mapGetters('user', ['currentRole']),
  },
  created() {
    window.addEventListener('resize', this.autoCollapse);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.autoCollapse);
  },
  methods: {
    ...mapActions('user', {
      userLogout: 'USER_LOGOUT',
    }),
    ...mapMutations(['collapseSiderbar']),
    isItemActive(active) {
      return this?.[active] || false;
    },
    showItem(visible) {
      return (typeof visible === 'boolean' && visible) || this?.[visible] || false;
    },
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
      this.collapseSiderbar(!this.sidebarCollapsed);
    },
    autoCollapse: _debounce(function hideSidebar(e) {
      this.sidebarCollapsed = e.target.innerWidth < 1024;
    }, 300),
    logout() {
      this.userLogout();
      this.$router.push('/login');
    },
  },
};
